
define('text!common/views/commercial/creatives/manual-container-button.html',[],function () { return '<a href="<%=clickMacro%><%=baseUrl%>" class="hide-until-mobile-landscape button button--primary button--large button--legacy-single" data-link-name="viewall">\n    <%=offerLinkText%>\n    <%=arrowRight%>\n</a>\n';});

